import CartContainer from "../../../components/applications/eCommerce/cart";

const Cart = () => {
  return <CartContainer />;
};

export default Cart;
